/* HeadlineList — clicking a headline opens the original newspaper URL in a new tab. */
const INSTITUTIONAL_CODES = new Set(["DIP"]);  // Cámara de Diputados (boletines oficiales)

export default function HeadlineList({ items, testId = "headline-list" }) {
  if (!items?.length) {
    return (
      <p className="py-3 text-sm text-sub font-sans" data-testid={`${testId}-empty`}>
        Sin notas en este apartado por el momento.
      </p>
    );
  }
  return (
    <ul className="border-t border-rule" data-testid={testId}>
      {items.map((a) => {
        const isOfficial = INSTITUTIONAL_CODES.has(a.source_code);
        return (
          <li key={a.id}>
            <a
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              className="headline-link group flex items-start gap-1 px-1"
              data-testid={`headline-${a.id}`}
              title={`Abrir en ${a.source_name}`}
            >
              <span className="source-badge mt-[3px]" title={a.source_name}>{a.source_code}</span>
              <span className="flex-1 text-[15px] leading-snug tracking-news">
                {isOfficial && (
                  <span
                    className="block font-mono text-[9px] uppercase tracking-[0.22em] text-rojo mb-0.5"
                    data-testid={`headline-official-${a.id}`}
                  >
                    Boletín oficial · {a.source_name}
                  </span>
                )}
                {a.title}
                {a.author ? (
                  <span className="ml-2 font-mono text-[10px] uppercase tracking-widest text-sub">
                    · {a.author}
                  </span>
                ) : null}
              </span>
              <span className="ml-1 text-sub text-[11px] mt-[2px]" aria-hidden>↗</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
}
